// extracted by mini-css-extract-plugin
export default {"main":"fon_main__6DP0P","image":"fon_image__CjXbd","box":"fon_box__BimkE","link":"fon_link__68rjp"};